import { db } from '../lib/firebase';
import { ref, get, set, child, push } from 'firebase/database';

export interface FlaggedImage {
  word: string;
  url: string;
  provider: string;
  flaggedBy: string;
  timestamp: number;
}

/**
 * Saves a flagged image match to the database.
 */
export async function flagImageMatch(
  word: string,
  url: string,
  provider: string,
  userId: string
): Promise<void> {
  const sanitizedWord = word.toLowerCase().replace(/[^a-z0-9]/g, '_');
  const flaggedRef = ref(db, `flaggedMemoryGameImages/${sanitizedWord}`);
  const newFlagRef = push(flaggedRef);

  const flagData: FlaggedImage = {
    word: sanitizedWord,
    url,
    provider,
    flaggedBy: userId,
    timestamp: Date.now(),
  };

  await set(newFlagRef, flagData);
}

/**
 * Retrieves all flagged URLs for a given word to avoid using them again.
 */
export async function getFlaggedUrlsForWord(word: string): Promise<string[]> {
  const sanitizedWord = word.toLowerCase().replace(/[^a-z0-9]/g, '_');
  const snapshot = await get(child(ref(db), `flaggedMemoryGameImages/${sanitizedWord}`));
  
  if (!snapshot.exists()) {
    return [];
  }

  const data = snapshot.val();
  const urls: string[] = [];
  
  Object.values(data).forEach((item: any) => {
    if (item && item.url) {
      urls.push(item.url);
    }
  });

  return urls;
}
